Vue.component('competition-table', {
	props: ['user', 'teams', 'competitor_teams', 'updating', 'sentimentbreakdown','updatingsentiment'],
	mounted() {

		this.$eventHub.$on('toggleAll', className => this.toggleAllByClassName(className));

	},
	data() {
		return {
			sourcesExpanded: false
		}
	},
	computed: {
		sentimentByTeam() {

			let filteredSentiment = {};

			for (team of this.competitor_teams)
			{
				for(sentimentType of this.sentimentbreakdown)
				{
					let sentimentEntry = sentimentType.data.find(entry => entry.team_id == team.team_id);
					let count = sentimentEntry.positive + sentimentEntry.negative;
					let average = Math.round( ( sentimentEntry.positive / (sentimentEntry.positive + sentimentEntry.negative) ) * 100 );

					if(!filteredSentiment[team.team_id]) 
					{
						filteredSentiment[team.team_id] = {};
					}else if(!filteredSentiment[team.team_id][sentimentType.name])
					{
						filteredSentiment[team.team_id][sentimentType.name] = {}
					}

					filteredSentiment[team.team_id][sentimentType.name] = 
						{
							average: average,
							count: count,
							positive: sentimentEntry.positive,
							negative: sentimentEntry.negative
						}
				}
			}

			return filteredSentiment;
		}
	},
	methods: {
		expandSources() {
			analytics.track("Toggled Competition Breakdown", {
				comparison_type: 'source',
				action: ! this.sourcesExpanded ? 'open' : 'close'
			})

			this.sourcesExpanded = ! this.sourcesExpanded
		},
		toggleAllByClassName(className) {
			elems = document.getElementsByClassName(className)


			let opened = false
			for (elem of elems) {
				if (! elem.classList.contains('expanded')) {
					opened = true
					elem.classList.add('expanded')
				} else {
					elem.classList.remove('expanded')
				}
			}

			analytics.track("Toggled Competition Breakdown", {
				comparison_type: className.replace("element-", "").replace("-", "_"),
				action: opened ? 'open' : 'close'
			})

		}
	}
})


Vue.component('competition-team', {
	props: ['team','sentimentbyteam','updatingsentiment'],
	data() {
		return {
			activePopover: false
		}
	},
	mounted() {

		$('[data-toggle="tooltip"]').tooltip();

		$('.compare[data-toggle="tooltip"]').tooltip({
			template: '<div class="tooltip tooltip-small"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
		})

		this.$eventHub.$on('toggleSourceExpansion', this.expandSources)

	},
	updated() {
		$('.compare[data-toggle="tooltip"]').tooltip()
	},
	computed: {
		type() {
			return Spark.state.currentTeam.type;
		},
		rankingLocationName() {
			try {
				return this.team.rankings.trip_advisor.location_name
			} catch (error) {
				return ''
			}
		},
		totalNegative() {
			return (parseInt(this.team.reviews_total_negative) + parseInt(this.team.reviews_total_neutral))
		},
		responseRate() {

			let val = this.team.responses.all_sources ?
				parseFloat(this.team.responses.all_sources.response_rate) : 0

			if (this.team.responses.all_sources && ! this.team.responses.all_sources.response_rate) {
				return '-'
			}

			return val.toFixed(0)
		},
		bestAndWorstCategory() {

			var lowest = Number.POSITIVE_INFINITY;
			var highest = Number.NEGATIVE_INFINITY;
			var tmp;

			let wc, bc = null

			for (category in this.team.sentiment_by_category) {
				tmp = this.team.sentiment_by_category[category].average;
				if (tmp < lowest) {
					lowest = tmp
					wc = category
				}
				if (tmp > highest) {
					highest = tmp
					bc = category
				}
			}

			if (! wc) wc = '-'
			if (! bc) bc = '-'

			let result =  {best: bc, worst: wc}
			return result

		},
		tripAdvisorRanking() {
			if ('trip_advisor' in this.team.rankings) {
				return this.team.rankings.trip_advisor
			} else {
				return null
			}
		},
		tripAdvisorRankingPosition() {

			let ranking = this.tripAdvisorRanking

			if (ranking && ranking.position != 0) {
				return ranking.position
			} else {
				return "-"
			}
		},
		overallAverageRating() {
			return this.team.ratings_total_average
		},
		teamSentimentAverage()
		{
			if (!this.sentimentbyteam) {
				return '';
			}
			let numPositive = 0;
			let numNegative = 0;

			for (let sentiment of Object.values(this.sentimentbyteam))
			{
				numPositive += sentiment.positive;
				numNegative += sentiment.negative;
			}

			if (numPositive + numNegative == 0) {
				return '-';
			}
			return (numPositive / (numPositive + numNegative) * 100).toFixed(0);
		}
	},
	methods: {
		positiveStyle(sentiment) {
			var style = 'background: #29a907;';
			var divBy = sentiment.positive + sentiment.negative;
			if (divBy == 0) {
				divBy = 1;
			}
			style += 'width: ' + ((sentiment.positive / divBy) * 100).toFixed(2) + '%;';
			return style;
		},
		expand(className) {
			// This implementation is a bit silly.. but it was made ages ago.
			// If anyone is in the mood to use a variable, props for the
			// child element and :class directives go ahead 
			this.$eventHub.$emit('toggleAll', className);
		},
		compare(type) {

			analytics.track("Compared Metric In Competition", {
				comparison_type: type
			})

			this.$eventHub.$emit('openComparison', type)
		},
		groupScore(group) {
            const sum = group.positive + group.negative;
            if (sum == 0) {
                return 0;
            }
            const ratio = group.positive / sum;
            return (ratio * 100).toFixed(0);
        },
		scoreClass(group) {
            const score = this.groupScore(group);
            if (score == 0) {
                return "";
            }
            if (score >= 80) {
                return "success";
            }
            if (score >= 60) {
                return "warning";
            }
            return "danger";
        },
		sentimentTooltip(stats, category) {
			//  has ${sentiment.positive} positive and ${sentiment.negative} negative mentions for ${sentiment_category}`
			return {
				content: this.team.name,
				placement: 'top'
			};
		},
		togglePopover() {
			this.activePopover = !this.activePopover;
		},
		closePopover() {
			this.activePopover = false;
		},
		deleteCompetitor(competitorId) {
			swal({
				title: "Are you sure?",
				text: `Are you sure you want to delete this competitor?`,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#DD6B55",
				confirmButtonText: "Yes, delete it!",
				closeOnConfirm: false
			},
			() => {
				axios.delete(`/api/competitors/${Spark.state.currentTeam.id}/deleteCompetitor/${competitorId}`)
					.then(response => {
						if (response.data.status === 'success') {
							this.$eventHub.$emit('updateCompetitors', true);
							swal("Deleted!", `Competitor has been removed.`, "success");
						} else {
							swal("Failed!", "Failed to delete the competitor.", "error");
						}
					})
					.catch(error => {
						console.error('Error deleting competitor:', error);
						swal("Error!", "An error occurred while deleting the competitor.", "error");
					});
			});
		}
	}
})

Vue.component('competition-date-picker', {
	props: ['from_date', 'to_date', 'active_comparison'],
	template: `
        <div ref="reviews_date_picker" class="dropdown-select date-picker">{{ date_text }}</div>
    `,

	computed: {

		date_text() {

			if (this.from_date == '' && this.to_date == '') {
				this.dateLabel = 'All time'
			}

			if (this.dateLabel != '') {
				return this.dateLabel
			} else {
				return this.from_date + '-' + this.to_date
			}
		}

	},
	watch: {
		from_date: function(newValue, oldValue) {
			try {
				this.fromDate = newValue.format("YYYY-MM-DD")
			} catch(error) {
				this.fromDate = newValue
			}
		},
		to_date: function(newValue, oldValue) {
			try {
				this.toDate = newValue.format("YYYY-MM-DD")
			} catch(error) {
				this.toDate = newValue
			}
		}
	},

	data() {
		return {
			fromDate: null,
			toDate: null,
			dateLabel: ''
		}
	},

	mounted() {

		moment.locale()

		let element = this.$refs.reviews_date_picker

		$(element).daterangepicker({
			ranges: this.getDefaultDateRanges(),
			autoApply: true,
			startDate: this.from_date,
			endDate: this.to_date,
			alwaysShowCalendars: true,
			opens: 'center',
			showDropdowns: true,
			minYear: 2000,
			maxYear: (new Date()).getFullYear() + 1
		}, this.updateDates)

		this.fromDate = this.from_date
		this.toDate = this.to_date
	},

	methods: {
		updateDates(fromDate, toDate, type) {

			this.dateLabel = type == "Custom Range" ? "" : type

			this.fromDate = fromDate
			this.toDate = toDate

			this.$eventHub.$emit('updateCompetitionDates', this.fromDate, this.toDate);

			if (this.active_comparison) {
				this.$eventHub.$emit('updateComparison', this.active_comparison)
			}

		}
	}
});

Vue.component('compare-ratings-chart', {
	props: ['average_ratings', 'competitors', 'sentiment', 'active_type', 'reviews', 'fontSize'],
	template: `
		<div id="competition-ratings-graph" class="comparison-chart modal-chart chart-scroll">
	    	<div class="graph-container dragscroll">
	        	<canvas v-show="readyToShowChart" id="competition_chart" ref="competition_ratings_chart" width="1200" height="400"></canvas>
				<div v-if="tooltipModel && tooltipModel.body" class="chart-tooltip chart-gray" :style="tooltipStyle">
	                <div class="chart-tooltip-inner">
		                <div class="legend">
	                        <h3>{{ tooltipModel.title[0] }}</h3>
	                    </div>
                    	<div class="body">
                    		<div class="hotel-you" >
                    			<p class="title">{{ labelFromLine(tooltipModel.body[0].lines[0]) }}</p>
                    			<p class="rating">{{ tooltipModel.dataPoints[0].yLabel }}<span class="small" v-if="active_type == 'average_rating'">/5</span></p>
                    		</div>
                    		<div class="comparison-hotels">
                    			<div v-for="i in tooltipModel.dataPoints.length - 1" class="comparison-hotel">
                    				<span class="title" :style="'color:' + chart.data.datasets[tooltipModel.dataPoints[i].datasetIndex].borderColor">{{ labelFromLine(tooltipModel.body[i].lines[0]) }}</span>
                    				<span class="rating">{{ tooltipModel.dataPoints[i].yLabel }}</span>
                    			</div>
                    		</div>
                    	</div>
	                </div>
	            </div>
			</div>
    	</div>`,
	computed: {
		readyToShowChart() {
			return true
		},
		tooltipStyle() {

			return {
				opacity: this.showTooltip ? 1 : 0,
				position: 'absolute',
				left: this.tooltipModel.caretX - 252 + 'px',
				top: this.tooltipModel.dataPoints[0].y - 210 + 'px',
				fontFamily: this.tooltipModel._bodyFontFamily,
				fontSize: this.tooltipModel.bodyFontSize + 'px',
				fontStyle: this.tooltipModel._bodyFontStyle
			}
		},
		maxReviewSize() {
			let max = 0

			for (comp of this.competitors) {
				if (comp.reviews_total_count > max) {
					max = comp.reviews_total_count
				}
			}

			return max
		}
	},
	mounted() {
		this.$eventHub.$on('toggleDataset', index => this.toggleDataset(index))
	},
	data() {
		return {
			chart: null,
			tooltipModel: null,
			showTooltip: false,
			colors: ['#00adf1', '#0153b9', '#f573db', '#8b73f5', '#44d3d1', '#e9d254', '#e4e4e4'],
			defaultColor: '#e4e4e4',
			scoreLine: {
				label: 'Score',
				type: 'line',
				data: [],
				fill: false,
				borderColor: 'rgb(0, 173, 241)',
				lineTension: 0,
				pointBackgroundColor: 'rgba(255, 255, 255, 1)',
				pointStrokeColor: 'rgba(0, 173, 241, 1)',
				pointHitDetectionRadius : 15,
				pointRadius: 5,
				pointBorderWidth: 3.5,
				borderWidth: 3,
				yAxisID: 'y-axis-1'
			}
		}
	},
	watch: {
		average_ratings: function (newValue, oldValue) {

			if (newValue == null) {
				return;
			}

			var instance = this
			if ( instance.chart) { instance.chart.destroy(); }

			Vue.nextTick(function () {
				chart = instance.$refs.competition_ratings_chart
				instance.prepareChart(chart)
				instance.prepareChartData()
			})

		},
		sentiment: function (newValue, oldValue) {

			if (newValue == null) {
				return;
			}

			var instance = this
			if ( instance.chart) { instance.chart.destroy(); }

			Vue.nextTick(function () {
				chart = instance.$refs.competition_ratings_chart
				instance.prepareChart(chart)
				instance.prepareChartData()
			})

		},
		reviews: function (newValue, oldValue) {

			if (newValue == null) {
				return;
			}

			var instance = this
			if ( instance.chart) { instance.chart.destroy(); }

			Vue.nextTick(function () {
				chart = instance.$refs.competition_ratings_chart
				instance.prepareChart(chart)
				instance.prepareChartData()
			})

		},
		active_type: function (newValue, oldValue) {

			if (newValue == null) {
				return;
			}

			var instance = this
			if ( instance.chart) { instance.chart.destroy(); }

			Vue.nextTick(function () {
				chart = instance.$refs.competition_ratings_chart
				instance.prepareChart(chart)
				instance.prepareChartData()
			})

		}
	},
	methods: {
		toggleDataset(index) {

			try {

				if (this.chart.data.datasets[index].hidden) {
					this.chart.data.datasets[index].hidden = false
				} else {
					this.chart.data.datasets[index].hidden = true
				}

				this.chart.update()
			} catch (error) {
				//
			}

		},
		labelFromLine(line) {
			let split = line.split(':')
			try {
				return split[0]
			} catch (error) {
				return ''
			}
		},
		prepareChartData() {

			let data = []

			// The index to use for the chart score value
			let score_index = ''

			switch (this.active_type) {
				case 'average_rating':
					data = this.average_ratings
					this.chart.options.scales.yAxes[0].ticks.stepSize = 0.5
					score_index = 'average'
					break
				case 'sentiment':
					data = this.sentiment
					this.chart.options.scales.yAxes[0].ticks.stepSize = 5
					score_index = 'average'
					break
				case 'reviews':
					data = this.reviews

					let step_size = this.maxReviewSize / 20

					if (step_size < 5) {
						step_size = 5
					}

					if (step_size > 100) {
						step_size = 100
					}

					this.chart.options.scales.yAxes[0].ticks.stepSize = step_size
					score_index = 'count'
					break
			}

			if (!data || data.length == 0) {
				return
			}

			for (i = 0; i < Object.keys(data).length; i++) {

				let scoreLine = JSON.parse(JSON.stringify(this.scoreLine))

				scoreLine.borderColor = i < this.colors.length ?
					this.colors[i] : this.defaultColor

				if (i != 0) {
					scoreLine.pointRadius = 3
					scoreLine.pointBorderWidth = 4
				}

				this.chart.data.datasets[i] = scoreLine
			}

			let index = 0

			for (let team in data) {

				try {
					this.chart.data.datasets[index].label = this.competitors[team].name
					this.chart.data.datasets[index].data = []
				} catch (error) {

				}

				for (period in data[team]) {

					let score = data[team][period]

					if (index == 0) {
						let period_label = '' + score.period
						this.chart.data.labels.push(period_label.toUpperCase())
					}

					if (score.average == 0) score.average = null
					this.chart.data.datasets[index].data.push(parseFloat(score[score_index]))
				}

				index++
			}

			console.log("Updating chart")
			this.chart.update()
		},
		prepareChart(area) {
			let ctx = area.getContext("2d")
			var vue_instance = this
			var isDrawn = false;

			Chart.plugins.register ( {
				afterDatasetsDraw: function(chart) {

					chart_type = chart.config.type;

					if (chart.tooltip._active && chart.tooltip._active.length && chart_type === 'line') {

						let activePoint = chart.tooltip._active[0],
							ctx = chart.chart.ctx,
							x_axis = chart.scales['x-axis-1'],
							y_axis = chart.scales['y-axis-1'],
							x = activePoint.tooltipPosition().x,
							y = activePoint.tooltipPosition().y,
							topY = y_axis.top,
							bottomY = y_axis.bottom


						// draw line
						ctx.save();

						// Create dotted line
						ctx.beginPath()
						ctx.moveTo(x, y)
						ctx.lineTo(x, bottomY + 10)
						ctx.setLineDash([2,1])
						ctx.lineWidth = 1
						ctx.strokeStyle = '#7b7b7b'
						ctx.stroke()

						// Create bottom circle
						ctx.beginPath()
						ctx.setLineDash([])
						ctx.lineWidth = 5
						ctx.fillStyle = '#fff'
						ctx.strokeStyle = '#7b7b7b'
						ctx.beginPath()
						ctx.arc(x, bottomY + 10, 5, 0, 2 * Math.PI)
						ctx.fill()
						ctx.stroke()

						ctx.restore()
					}
				}
			});

			this.chart = new Chart(area, {
				type: 'line',
				data: {
					labels: [],
					datasets: []
				},
				options: {
					spanGaps: true,
					legend: {
						display: false
					},
					responsive: false,
					maintainAspectRatio: false,
					scales : {
						yAxes : [
							{
								type: 'linear',
								id: 'y-axis-1',
								ticks : {
									stepSize: 0.5,
									fontColor: '#9696a4'
								},
								scaleLabel: {
									display: true,
									labelString: 'S C O R E',
									fontColor: '#9696a4',
                                    fontSize: this.fontSize || 14
								},
								gridLines: {
									color: "#f2f2f2"
								}
							}
						],
						xAxes: [
							{
								gridLines: {
									tickMarkLength: 25
								},
                                ticks: {
                                    fontSize: this.fontSize || 14,
                                    fontColor: this.text_color
                                },
							}
						]
					},
					tooltips: {

						intersect: false,
						enabled: false,
						mode: 'label',

						custom: function(tooltipModel) {
							if (tooltipModel.title) {
								vue_instance.tooltipModel = tooltipModel
								vue_instance.showTooltip = true
							} else {
								// vue_instance.tooltipModel = tooltipModel
								vue_instance.showTooltip = false
							}
						}
					},
					animation: {
						onComplete: function() {
							if (! isDrawn ) {
								isDrawn = true;
								$('#competition-ratings-graph').scrollLeft(16000)
							}
						}
					}
				},
			});
		}
	}
})
